export default {
    // --------Title--------
    rolesAssignation: 'Roles Assignation',
    addingRoleTitleWithDetails: 'Adding role title with details',
    permissions: 'Permissions',
    selectWhichActionsThePeopleWithThisRoleCanPerform: 'Select which actions the people with this role can perform',

    // --------Permission-------
    branchUsers: 'Branch Users',
    
    // --------MUI--------
    userRouteType: 'User Route Type',
    roleTitle: 'Role Title',
    mainUsers: 'Main Users',

};